import React from "react";
import PropTypes from "prop-types";

import { UserIcon, AVATAR_SIZE } from "widgets/datadisplay";

import styles from "./style.css";

export function MultiUser(props) {
  const { value, wrap = false } = props;
  return (
    <div
      className={`${styles.multiselect} ${wrap ? styles.multiselectwrap : ""}`}
    >
      {value &&
        value.map &&
        value.map((val) => {
          return (
            <span className={styles.chip} key={val}>
              {
                <React.Fragment>
                  <UserIcon
                    userId={val._id}
                    name={val.Name}
                    size={AVATAR_SIZE.SIZE20}
                  />
                  <span
                    style={{ marginInlineStart: "var(--space-8)" }}
                    className={"ellipsis"}
                  >
                    {val.Name}
                  </span>
                </React.Fragment>
              }
            </span>
          );
        })}
    </div>
  );
}

MultiUser.propTypes = {
  value: PropTypes.array,
  wrap: PropTypes.bool
};
